// import Vue from 'vue';
import { defaultSettings } from './settings.const';
import { v4 as uuid } from 'uuid';

function isDayOff(date) {
    return !date;
}

function getWorkingHoursInMonth(year, month) {
    let result = 0;
    let date = new Date(year, month - 1);
    while (date.getMonth() !== (month - 1)) {
        let day = date.getDay();
        if (day >= 1 && day <= 5 && !isDayOff(date)) {
            result++;
        }
        date.setDate(date.getDate() + 1);
    }

    return result;
}

export default class {
    wallets = [];
    wishlist = [];
    settings = defaultSettings();

    constructor() {

    }

    async init() {
        await this.refreshSetting();
        await this.refreshWallets();
        await this.refreshWishlist();
        return true;
    }

    refreshWallets() {
        throw 'refreshWallets method should be overrited';
    }

    loadSettings() {
        return Promise.resolve({});
    }

    saveSetting() {
        throw 'saveSetting method should be overrited';
    }

    refreshSetting() {
        this.loadSettings().then((result) => {
            let { general, salaries, expenses } = result;

            this.settings.general = Object.assign(this.settings.general, {}, general);
            this.settings.salaries = salaries || [];
            this.settings.expenses = expenses || [];
        });
    }

    loadWishlist() {
        return Promise.resolve({});
    }

    saveWishlist() {
        throw 'saveSetting method should be overrited';
    }

    refreshWishlist() {
        this.loadWishlist()
            .then((result) => {
                this.wishlist = result || [];
            });
    }

    walletMethods() {
        return {
            save() {
                throw 'save method should be overrited';
            },
            remove() {
                throw 'delete method should be overrited';
            },
            reset() {
                throw 'reset method should be overrited';
            }
        }
    }

    newPeriod() {
        const today = new Date();

        let years = this.wallets.map(item => item.year);
        let year = Math.max.apply(null, [...years, today.getFullYear()]);

        let months = this.wallets.filter(item => item.year == year).map(item => item.month);
        let month;
        if (today.getMonth() === year) {
            month = Math.max.apply(null, [...months, today.getMonth()]) + 1;
        } else {
            month = Math.max.apply(null, months) + 1;
        }

        if (month == 13) {
            year++;
            month = 1;
        }

        return {
            year,
            month
        }
    }

    walletWrappering(wallet) {
        Object.assign(wallet, this.walletMethods());
    }

    addWallet(year, month, data) {
        let wallet = { year, month, data };
        this.walletWrappering(wallet);
        this.wallets.push(wallet);
        // let key = this.wallets.length;
        // Vue.set(this.wallets, key, wallet);
        return wallet;
    }

    removeWallet(wallet) {
        let index = this.wallets.indexOf(wallet);
        if (index > -1) {
            this.wallets.splice(index, 1);
        }
        return wallet;
    }

    getWallet(year, month) {
        let wallet = this.wallets.find(item => item.year == year && item.month == month);
        return Promise.resolve(wallet);
    }

    newWalletData(year, month) {
        let workingHoursInMonth = getWorkingHoursInMonth(year, month);

        let salaries = this.settings.salaries
            .filter((salary) => {
                return salary.months && (salary.months.indexOf(month) > -1) || !month;
            })
            .map((salary) => {
                let result = this.copyOf(salary);
                result.hours = result.hours || (workingHoursInMonth * result.hoursPerDay);
                delete result.months;
                return result;
            });

        let expenses = this.settings.expenses
            .filter((expense) => {
                return expense.months && (expense.months.indexOf(month) > -1) || !month;
            })
            .map((expense) => {
                let result = this.copyOf(expense);
                result.date = new Date(year, month - 1, parseInt(result.day) || 1);

                if (!parseInt(result.day)) {
                    result.date.setMonth(result.date.getMonth() + 1);
                    result.date.setDate(result.date.getDate() - 1);
                }

                delete result.months;
                delete result.day;

                return result;
            });

        return { salaries, expenses };
    }


    addSalary(wallet, salary) {
        wallet.data.salaries = wallet.data.salaries || [];
        wallet.data.salaries.push(salary);
    }

    addExpense(wallet, expense) {
        wallet.data.expenses = wallet.data.expenses || [];
        wallet.data.expenses.push(expense);
    }


    newWallet() {
        return {
            id: undefined,
            year: undefined,
            month: undefined,
            data: undefined,
        }
    }

    newSalary(additionals) {
        return Object.assign({
            id: uuid(),
            name: undefined,
            description: undefined,
            value: undefined,
            hours: undefined,
            hoursPerDay: undefined,
            overtimes: undefined
        }, additionals);
    }

    newWish() {
        return {
            id: uuid(),
            name: undefined,
            description: undefined,
            value: undefined
        }
    }

    newOvertime() {
        return {
            id: uuid(),
            percent: undefined,
            hours: undefined
        }
    }

    newExpense(additionals) {
        return Object.assign({
            id: uuid(),
            parent: undefined,
            name: undefined,
            description: undefined,
            value: undefined,
            date: undefined,
            done: false
        }, additionals);
    }


    import() {
        throw 'import method should be overrited';
    }

    export() {
        throw 'export method should be overrited';
    }


    copyOf(obj) {
        return JSON.parse(JSON.stringify(obj));
    }

    salaryDetails(salary) {
        let { type = "month", value, hours, hoursPerDay = 8 } = salary;

        let valuePerMonth = type === "hour" ? value * hours : value;
        let valuePerHour = type === "hour" ? value : value / hours;
        let days = hours / hoursPerDay || undefined;
        let sum = parseFloat(valuePerMonth) + (salary.overtimes || []).reduce((sum, current) => sum + (current.percent * current.hours * valuePerHour / 100), 0);

        return {
            valuePerMonth,
            valuePerHour,
            days,
            sum
        }
    }

    sumExpenses(expenses = []) {
        return expenses
            .filter(expense => !expense.parent)
            .map(expense => {
                if (!expense.value) {
                    return expenses
                        .filter(child => child.parent === expense.id)
                        .map(child => parseFloat(child.value) || 0)
                        .reduce((sum, current) => sum + current, 0);
                } else {
                    return parseFloat(expense.value);
                }
            })
            .reduce((sum, current) => sum + current, 0);
    }

    sumSalaries(salaries = []) {
        return salaries
            .map(salary => this.salaryDetails(salary))
            .reduce((sum, current) => sum + current.sum, 0);
    }
}